var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('photo-shooter',{ref:"shooter",on:{"photoReady":function($event){_vm.photoReady = $event}}}),_c('div',{staticClass:"d-flex justify-center"},[(_vm.photoReady)?_c('v-btn',{staticClass:"rounded-pill mb-5",style:({
        color: _vm.buttonTextValidColor,
        fontWeight: 600,
        fontSize: 16,
        fontFamily: 'Georama',
        textTransform: 'none',
      }),attrs:{"disabled":_vm.uploading,"loading":_vm.uploading,"width":"310","height":"52px","color":_vm.buttonValidColor},on:{"click":_vm.saveAndContinue}},[_vm._v("Continuer ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }